import { h } from '@stencil/core';

const Icon = ({ width = 'auto', height = 'auto' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="#F2F2F2" viewBox="0 0 64 64">
      <g>
        <g>
          <defs>
            <polygon
              points="-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593
                  -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593"
            />
          </defs>
        </g>
      </g>
      <g>
        <g>
          <defs>
            <path
              d="M-508.177-1629.66c0.824,0,1.492-0.682,1.492-1.523s-0.668-1.523-1.492-1.523s-1.492,0.682-1.492,1.523
                  S-509.001-1629.66-508.177-1629.66z M-508.177-1634c1.282,0.001,2.394,0.903,2.685,2.178h6.37c0.35,0,0.634,0.29,0.634,0.648
                  c0,0.357-0.284,0.647-0.634,0.647h-6.348c-0.352,1.514-1.84,2.45-3.323,2.091c-1.015-0.246-1.807-1.055-2.048-2.091h-2.022
                  c-0.35,0-0.634-0.29-0.634-0.648c0-0.357,0.284-0.647,0.634-0.647h2.022C-510.551-1633.089-509.451-1633.988-508.177-1634z
                  M-503.811-1624.307c0.824,0,1.492-0.682,1.492-1.523s-0.668-1.523-1.492-1.523s-1.492,0.682-1.492,1.523
                  S-504.635-1624.307-503.811-1624.307z M-503.811-1628.647c1.274,0.012,2.374,0.912,2.663,2.178h2.022
                  c0.35,0,0.634,0.29,0.634,0.647c0,0.357-0.284,0.647-0.634,0.648h-2.022c-0.241,1.036-1.033,1.845-2.048,2.09
                  c-1.483,0.359-2.971-0.577-3.323-2.09h-6.348c-0.35,0-0.634-0.29-0.634-0.647c0-0.357,0.284-0.647,0.634-0.648h6.37
                  C-506.205-1627.744-505.093-1628.646-503.811-1628.647z"
            />
          </defs>
        </g>
      </g>
      <g>
        <polygon points="27.767,17.975 25.417,24.067 39.78,24.067 41.111,17.975 	" />
        <path d="M48.653,24.067h-2.654v-2.77h4.135v1.289C50.134,23.404,49.471,24.067,48.653,24.067z" />
        <path d="M22.763,24.067h2.654v-2.77h-4.135v1.289C21.282,23.404,21.945,24.067,22.763,24.067z" />
      </g>
      <path
        d="M10.957,0.362v31.531c-0.002,0-0.015,0-0.015,0v20.466h0.015v0.583h52.579V0.362H10.957z M24.397,28.182v-0.657l3.902,0.748
            l2.134,1.394h-4.557C25.06,29.667,24.397,29.002,24.397,28.182z M26.66,36.691c0.476-0.458,0.776-1.097,0.776-1.806v-1.345h16.857
            v1.345c0,0.709,0.3,1.348,0.776,1.806H26.66z M47.538,28.129c0,0.849-0.686,1.538-1.532,1.538h-4.505l2.134-1.394l3.902-0.748
            V28.129z M61.565,29.496c-1.103,0.379-2.428,0.871-3.286,1.311c-1.703,0.873-3.114,2.023-4.448,3.199
            c-0.453,0.4-0.911,0.809-1.388,1.203c-0.929,0.769-2.185,1.25-3.539,1.409c0.433-0.452,0.703-1.061,0.703-1.732v-1.345v-2.359
            v-4.813H22.121v4.813v2.359v1.345c0,0.443,0.126,0.854,0.329,1.216c-0.199-0.109-0.39-0.228-0.56-0.366
            c-0.831-0.676-1.56-1.457-2.415-2.116c-0.757-0.583-1.634-1.079-2.59-1.468c-0.258-0.105-2.33-0.177-3.957-0.218v-29.6h48.636
            V29.496z"
      />
      <path d="M10.751,31.39" />
      <path d="M10.751,31.39" />
      <path d="M10.751,31.39" />
      <polygon points="5.647,58.252 5.647,10.878 0.441,10.878 0.441,60.589 0.441,63.457 3.309,63.457 53.021,63.457 52.969,58.252 " />
    </svg>
  );
};

export default Icon;
